// extracted by mini-css-extract-plugin
module.exports = {"item":"TodoItem_item__2xhq_","checkbox":"TodoItem_checkbox__7qQOb","textInput":"TodoItem_textInput__25nOk"};